
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-120cdb97&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductsList.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductsList.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-120cdb97!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductsList.vue"),
  /* scopeId */
  "data-v-120cdb97",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsList.vue
// module id = 370
// module chunks = 0